import { createAsyncThunk } from '@reduxjs/toolkit';
// 2023/04/26 Leading Win WEB側写真合成の工種の選択肢不正対応 start
// import { siteService } from 'services';
import { siteService, workerService } from 'services';
// 2023/04/26 Leading Win WEB側写真合成の工種の選択肢不正対応 end
import * as types from 'types';

export const getListAgent = createAsyncThunk<
  types.GetListAgentResponse,
  types.GetListAgentRequest,
  types.ThunkAPI<types.GetListAgentError>
>('supportSiteList/thunk/getListAgent', async (params, { rejectWithValue }) => {
  try {
    const { data: dataListAgent } = await siteService.getListAgent(params);
    return dataListAgent;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getSiteShopList = createAsyncThunk<
  types.GetUserSiteShopListResponse,
  types.GetUserSiteShopListRequest,
  types.ThunkAPI<types.GetUserSiteShopListError>
>('tableGantt/thunk/site/shop_list', async (params, { rejectWithValue }) => {
  try {
    const { data } = await siteService.getSiteShopList(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getStatusKy = createAsyncThunk<
  types.GetStatusKyResponse,
  types.GetStatusKyRequest,
  types.ThunkAPI<types.GetStatusKyError>
>('get/ky_datas_approved_by_site_director', async (params, { rejectWithValue }) => {
  try {
    const { data } = await siteService.getStatusKy(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

// 2023/04/26 Leading Win WEB側写真合成の工種の選択肢不正対応 start
export const getPerformanceWorkType = createAsyncThunk<
  types.GetPerformanceWorkerTypeResponse,
  types.GetPerformanceWorkerTypeRequest,
  types.ThunkAPI<types.GetPerformanceWorkerTypeError>
>('get/performance/work_type', async (params, { rejectWithValue }) => {
  try {
    const { data } = await workerService.getPerformanceWorkType(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
// 2023/04/26 Leading Win WEB側写真合成の工種の選択肢不正対応 end
